import { useState } from 'preact/hooks';
import { lazy, Suspense } from 'preact/compat';
import { MessageSquare } from 'lucide-preact';
import { Button } from '@/components/primitives/Button';
import { isCmoOrAdmin } from '@/stores/rbac';

// El panel va en la cabecera de todas las páginas pero solo lo abren CMO y
// admin: se carga al abrirlo por primera vez y luego se queda montado para
// conservar la conversación al cerrarlo.
const AssistantPanel = lazy(() =>
  import('./AssistantPanel').then((m) => ({ default: m.AssistantPanel })),
);

export function AssistantLauncher() {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  if (!isCmoOrAdmin.value) return null;
  return (
    <>
      <Button
        size="sm"
        leftIcon={MessageSquare}
        onClick={() => {
          setLoaded(true);
          setOpen(true);
        }}
        aria-haspopup="dialog"
      >
        Asistente
      </Button>
      {loaded && (
        <Suspense fallback={null}>
          <AssistantPanel open={open} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
